import {addEvent} from '../add-event'

export function viewReportsEvent(trigger: string, pageVersion: string): boolean {
    return addEvent('viewReports', {from: trigger, pageVersion})
}
